export const INITIAL_CUSTOMERS = [
  {
    id: "CUST-W01",
    name: "Paradise Food Court & Caterers (Secunderabad)",
    type: "Wholesale",
    segment: "B2B Hospitality / Biryani Chain",
    contactPerson: "Syed Mujeeb",
    phone: "+91 98480 12345",
    email: "procurement@paradisehyd.in",
    city: "Secunderabad",
    creditLimit: 500000,
    creditDays: 30,
    outstandingBalance: 145000,
    totalSalesYTD: 1420000,
    rating: "Tier-1 A+ Buyer"
  },
  {
    id: "CUST-W02",
    name: "Bawarchi Biryani & Restaurant (RTC X Roads)",
    type: "Wholesale",
    segment: "B2B Restaurant & Bulk Rice Buyer",
    contactPerson: "Mohammad Irfan",
    phone: "+91 98480 23456",
    email: "bawarchihyd@gmail.com",
    city: "Hyderabad",
    creditLimit: 350000,
    creditDays: 21,
    outstandingBalance: 88000,
    totalSalesYTD: 890000,
    rating: "Reliable B2B"
  },
  {
    id: "CUST-W03",
    name: "Sri Balaji Kirana & General Stores (Madhapur)",
    type: "Wholesale",
    segment: "B2B Retail Kirana Partner",
    contactPerson: "Balaji Gupta",
    phone: "+91 98480 34567",
    email: "balajikirana.hitec@gmail.com",
    city: "Hyderabad",
    creditLimit: 200000,
    creditDays: 15,
    outstandingBalance: 42000,
    totalSalesYTD: 480000,
    rating: "Prompt Payer"
  },
  {
    id: "CUST-W04",
    name: "Pista House Sweet & Bakery (Charminar)",
    type: "Wholesale",
    segment: "B2B Bakery & Sweets Manufacturer",
    contactPerson: "Khaja Majeed",
    phone: "+91 98480 45678",
    email: "orders@pistahouse.in",
    city: "Hyderabad",
    creditLimit: 600000,
    creditDays: 30,
    outstandingBalance: 210000,
    totalSalesYTD: 1950000,
    rating: "Premium Key Account"
  },
  {
    id: "CUST-W05",
    name: "Sri Venkateshwara Supermarket (Dilsukhnagar)",
    type: "Wholesale",
    segment: "Semi-Wholesale Mart",
    contactPerson: "K. Venkatesh",
    phone: "+91 98480 56789",
    email: "venkateshwaramart@gmail.com",
    city: "Hyderabad",
    creditLimit: 250000,
    creditDays: 21,
    outstandingBalance: 64000,
    totalSalesYTD: 620000,
    rating: "Regular Partner"
  },
  {
    id: "CUST-W06",
    name: "Gachibowli IT Hostels & Mess Union",
    type: "Wholesale",
    segment: "Institutional Mess & Catering",
    contactPerson: "Srinivas Goud",
    phone: "+91 98480 67890",
    email: "messunion.gachibowli@gmail.com",
    city: "Hyderabad",
    creditLimit: 300000,
    creditDays: 14,
    outstandingBalance: 95000,
    totalSalesYTD: 780000,
    rating: "High Volume"
  },
  {
    id: "CUST-W07",
    name: "Chutneys Family Restaurant (Banjara Hills)",
    type: "Wholesale",
    segment: "Vegetarian Dining Chain",
    contactPerson: "N. Ramakrishna",
    phone: "+91 98480 78901",
    email: "purchase@chutneys.co.in",
    city: "Hyderabad",
    creditLimit: 400000,
    creditDays: 30,
    outstandingBalance: 115000,
    totalSalesYTD: 1100000,
    rating: "A+ Account"
  },
  {
    id: "CUST-R01",
    name: "Dr. K. S. Rao (Jubilee Hills)",
    type: "Retail",
    segment: "Monthly Account Household",
    contactPerson: "Dr. K. S. Rao",
    phone: "+91 98480 89012",
    email: "ksrao.doc@yahoo.com",
    city: "Hyderabad",
    creditLimit: 30000,
    creditDays: 30,
    outstandingBalance: 8400,
    totalSalesYTD: 74000,
    rating: "Loyal Retail VIP"
  },
  {
    id: "CUST-R02",
    name: "Mrs. Padmavati Sharma (KPHB Colony)",
    type: "Retail",
    segment: "Monthly Account Household",
    contactPerson: "Padmavati Sharma",
    phone: "+91 98480 90123",
    email: "padma.sharma@gmail.com",
    city: "Hyderabad",
    creditLimit: 25000,
    creditDays: 30,
    outstandingBalance: 6200,
    totalSalesYTD: 58000,
    rating: "Regular Retail"
  },
  {
    id: "CUST-R03",
    name: "V. Anand Kumar (Mehdipatnam)",
    type: "Retail",
    segment: "Walk-in Regular",
    contactPerson: "V. Anand Kumar",
    phone: "+91 98481 01234",
    email: "anand.kumar@gmail.com",
    city: "Hyderabad",
    creditLimit: 15000,
    creditDays: 15,
    outstandingBalance: 0,
    totalSalesYTD: 42000,
    rating: "Instant UPI Payer"
  },
  {
    id: "CUST-R04",
    name: "Walk-in Retail Shopper (Counter POS)",
    type: "Retail",
    segment: "Cash & UPI Counter Shopper",
    contactPerson: "Direct Retail Customer",
    phone: "+91 98480 00000",
    email: "walkin@kiranastore.com",
    city: "Hyderabad",
    creditLimit: 0,
    creditDays: 0,
    outstandingBalance: 0,
    totalSalesYTD: 284000,
    rating: "Spot Cash / QR Code"
  }
];

export const initialCustomers = INITIAL_CUSTOMERS;

